<template>
  <div class="top" :class="type === 'dt' ? 'dt' : ''">
    <div v-if="type === 'ep'" class="txt txtep">
      <p class="txt-p1">免费试用</p>
      <p class="ft-20">30天无条件退款</p>
      <p class="txt-p2">根据场景灵活选配，无隐形收费项</p>
    </div>
    <div v-else-if="type === 'dt'" class="txt txtep td_conten">
      <p class="txt-p1">ToDesk云电脑</p>
      <p class="ft-20">独享满血高性能显卡，手机、平板、<br />PC皆可使用</p>
    </div>
    <div v-else class="txt">
      <p class="txt-p1">性能版全新上线</p>
      <p class="ft-20">移动端支持2K60HZ流畅切换</p>
      <p class="txt-p2">购买专业版、游戏版或性能版可享受部分商品<br />专属折扣</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="less" scoped>
.top.dt {
  position: relative;
}

.txt {
  text-align: center;
  font-size: 32px;
  font-weight: bold;
  line-height: 51px;
  padding-top: 32px;
  padding-bottom: 0px;
  height: 150px;
  box-sizing: border-box;
  .txt-p1 {
    margin-bottom: 8px;
    font-size: 30px;
    line-height: 38px;
  }
  .txt-p2 {
    margin-top: 2px;
    font-size: 14px;
    line-height: 22px;
    color: #22282B;
    font-weight: 400;
  }
  .ft-20 {
    font-size: 18px;
    line-height: 28px;
    color: #22282B;
  }
}
</style>
